import React from 'react';

import { cssMap } from '@atlaskit/css';
import { IconTile } from '@atlaskit/icon';
import GlobeIcon from '@atlaskit/icon/core/globe';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	globeBlueCircle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '32px',
		height: '32px',
		borderRadius: token('radius.full'),
		backgroundColor: token('color.background.accent.blue.subtler'),
	},
});

const IconSizeExample = (): React.JSX.Element => {
	return (
		<Inline space="space.200">
			<IconTile icon={GlobeIcon} label="" appearance="blue" shape="square" size="medium" />
			<IconTile
				icon={GlobeIcon}
				label=""
				appearance="blue"
				shape="circle"
				size="medium"
				UNSAFE_circleReplacementComponent={
					<Box xcss={styles.globeBlueCircle}>
						<svg width="32" height="32" fill="none" viewBox="0 0 24 24" aria-hidden="true">
							<g transform="translate(4 4)">
								<path
									fill={token('color.icon.accent.blue')}
									fillRule="evenodd"
									d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229"
									clipRule="evenodd"
								/>
							</g>
						</svg>
					</Box>
				}
			/>
		</Inline>
	);
};

export default IconSizeExample;
